export const TEXT = {
    DatabaseRecords: {en: "Database Records", ar: "سجلات قاعدة البيانات"},
    BackToBrowser: {en: "Back to Browser", ar: "العودة إلى المتصفح"},
    Fields: {en: "fields", ar: "حقول"},
    Records: {en: "records", ar: "سجلات"},
    Local: {en: "Local", ar: "محلي"},
    Global: {en: "Global", ar: "عام"},
    Version: {en: "Version", ar: "الإصدار"},
    AddRecord: {en: "Add Record", ar: "إضافة سجل"},
    EditRecord: {en: "Edit Record", ar: "تعديل السجل"},
    DeleteRecord: {en: "Delete", ar: "حذف"},
    SaveRecord: {en: "Save", ar: "حفظ"},
    Cancel: {en: "Cancel", ar: "إلغاء"},
    ConfirmDelete: {en: "Are you sure you want to delete this record?", ar: "هل أنت متأكد من حذف هذا السجل؟"},
    RecordDeleted: {en: "Record deleted successfully", ar: "تم حذف السجل بنجاح"},
    RecordSaved: {en: "Record saved successfully", ar: "تم حفظ السجل بنجاح"},
    NoRecords: {en: "No records yet. Add one to get started.", ar: "لا توجد سجلات بعد. أضف واحدة للبدء."},
    NoPermission: {en: "You don't have permission to perform this action", ar: "ليس لديك إذن لتنفيذ هذا الإجراء"},
    FillAllFields: {en: "Please fill all mandatory fields", ar: "يرجى ملء جميع الحقول المطلوبة"},
    Actions: {en: "Actions", ar: "إجراءات"},
    Error: {en: "Error", ar: "خطأ"},
    Permission: {en: "Permission", ar: "الصلاحية"},
    Owner: {en: "Owner", ar: "مالك"},
    Admin: {en: "Admin", ar: "مسؤول"},
    Contributor: {en: "Contributor", ar: "مساهم"},
    Reader: {en: "Reader", ar: "قارئ"},
    NoDatabaseSelected: {en: "No database selected. Please return to browser.", ar: "لم يتم تحديد قاعدة بيانات. يرجى العودة إلى المتصفح."},
    DbGroupNotFound: {en: "Database template not found", ar: "قالب قاعدة البيانات غير موجود"},
    BasedOn: {en: "Based on", ar: "مبني على"},
    ViewRecord: {en: "View Record", ar: "عرض السجل"},
    OpenRecord: {en: "Open Record", ar: "فتح السجل"},
    QuickView: {en: "Quick View", ar: "عرض سريع"},
    OpenInPage: {en: "Open in Page", ar: "فتح في صفحة"},
    RecordDetails: {en: "Record Details", ar: "تفاصيل السجل"},
    Close: {en: "Close", ar: "إغلاق"},
    Edit: {en: "Edit", ar: "تعديل"},
    ManageAccess: {en: "Manage Access", ar: "إدارة الوصول"},
    ManagePermissions: {en: "Manage Permissions", ar: "إدارة الصلاحيات"},
    SearchUsers: {en: "Search users by name, email, or ID...", ar: "البحث عن المستخدمين بالاسم أو البريد أو المعرف..."},
    AddUser: {en: "Add User", ar: "إضافة مستخدم"},
    RemoveUser: {en: "Remove", ar: "إزالة"},
    Owners: {en: "Owners", ar: "المالكون"},
    Admins: {en: "Admins", ar: "المسؤولون"},
    Contributors: {en: "Contributors", ar: "المساهمون"},
    Readers: {en: "Readers", ar: "القراء"},
    Supervised: {en: "Supervised", ar: "تحت الإشراف"},
    NoUsersInGroup: {en: "No users in this group", ar: "لا يوجد مستخدمون في هذه المجموعة"},
    PermissionUpdated: {en: "Permission updated successfully", ar: "تم تحديث الصلاحية بنجاح"},
    CannotRemoveLastOwner: {en: "Cannot remove the last owner", ar: "لا يمكن إزالة المالك الأخير"},
    UserNotFound: {en: "User not found", ar: "المستخدم غير موجود"},
    SelectPermissionType: {en: "Select permission type", ar: "اختر نوع الصلاحية"},
    OwnersDescription: {en: "Full control over the database", ar: "تحكم كامل في قاعدة البيانات"},
    AdminsDescription: {en: "Can edit and manage permissions", ar: "يمكن التعديل وإدارة الصلاحيات"},
    ContributorsDescription: {en: "Can add new records", ar: "يمكن إضافة سجلات جديدة"},
    ReadersDescription: {en: "Can only view records", ar: "يمكن فقط عرض السجلات"},
    SupervisedDescription: {en: "Edits require approval", ar: "التعديلات تتطلب موافقة"},
}
export default TEXT;
